export default {"src":"/_next/static/media/aadharcode.8d0cb5f3.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};